module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__average-diff-table"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('th', [_vm._v("\n                " + _vm._s(_vm.headingLabels.from) + " vs " + _vm._s(_vm.headingLabels.to) + "\n            ")]), _vm._v(" "), _c('th', [_vm._v("\n                Amount (£)\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-align-items"
  }, [_c('span', {
    staticClass: "u-margin-right-10",
    style: ('background: ' + _vm.colours[0])
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.fromLabel))])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.currencyFormat(_vm.averageFrom)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-align-items"
  }, [_c('span', {
    staticClass: "u-margin-right-10",
    style: ('background: ' + _vm.colours[1])
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.toLabel))])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.currencyFormat(_vm.averageTo)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-align-items"
  }, [_c('span', {
    staticClass: "u-margin-right-10",
    style: ('background: ' + _vm.colours[2])
  }), _vm._v(" "), _c('div', [_vm._v("Difference")])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.currencyFormat(Math.abs(_vm.difference))))]), _vm._v(" "), _c('div', {
    staticClass: "p-compare-reserve__average-diff-table--percent"
  }, [_vm._v("\n                    ("), _c('span', [_vm._v(_vm._s(_vm.roundValue(_vm.differencePercent)) + "% average difference")]), _vm._v(")\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c740e94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/DifferenceTable.vue
// module id = 1739
// module chunks = 0